var pickYourCountry = 'https://bioeffect.com/pages/pick-your-country';
var ipInfo = 'https://ipinfo.io';
var homePage = 'https://bioeffect.com/';
var bioEffectIndex = "https://www.bioeffect.com/index";

$(document).ready(function() {
  $('[data-toggle=readmore]').click(function() {
  	var target = $(this).data('target');
    var text = $(this).text();
    
    $('[data-readmore='+target+']').toggleClass('expanded');
    if ( text == 'Read More +' ) $(this).text('Read Less -');
    else $(this).text('Read More +');
  });
  
  if (window.location.href.indexOf("pick-your-country") > -1) {
    $(".preheader, .footer-bar, footer, ul.nav.navbar-nav.navbar-center.text-xs.text-lowercase, form.navbar-form.navbar-right.hidden-xs, .nav-more, ul.nav.navbar-nav.navbar-right.text-sm, .navbar-nav").hide();
    $("a.navbar-brand").attr("href", bioEffectIndex);
  }
  
  if (window.location.href.indexOf("/index") > -1) {
    $("a.navbar-brand").attr("href", bioEffectIndex);
  }
  
  $(".country-link").click(function(){
    // create cookie based on their country of choice via click
    createCookie("countryPage", $(this).attr('href'), 30);
  })
  
  // Conditional to redirect users based on country picked using cookies
  
  if(window.location.pathname === "/" && readCookie("countryPage") === bioEffectIndex){
    // cookie exists and leads to index
    window.location.replace(bioEffectIndex)
  } else if (window.location.pathname === "/" && document.cookie.indexOf("countryPage") >=0 ) {
//     cookie exists and will redirect to respective site
    window.location.replace(readCookie("countryPage"))
  } else if (window.location.pathname === "/") {
    // fresh user; no cookies and will redirect if customer is international
    intlRedirect();
  }
  
	whiteFader();
});

// Creating a cookie

function createCookie(name,value,days) {
    if (days) {
      var date = new Date();
      date.setTime(date.getTime()+(days*24*60*60*1000));
      var expires = "; expires="+date.toGMTString();
    }
    else var expires = "";
    document.cookie = name+"="+value+expires+"; path=/";
}

function readCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
}

function eraseCookie(name) {
    createCookie(name,"",-1);
}

// White loader/fader

function whiteOverlay() {
  $(".main").append("<div class=\"overlay\"><div class=\"loader\"><svg class=\"circular\"><circle class=\"path\" cx=\"50\" cy=\"50\" r=\"20\" fill=\"none\" stroke-width=\"2\" stroke-miterlimit=\"10\"/></svg></div></div>");
}

function whiteFader() {
  setTimeout(function(){
    $(".overlay").fadeOut("slow")
  }, 1800);
}

// Redirect for international customers

function intlRedirect() {  
  $.getJSON(ipInfo, function(data) {
    if (window.location.href === homePage && data.country != 'US'){
      whiteOverlay();
      window.location.replace(pickYourCountry)
    }
    
    if (data.country != 'US') {
      $("a.navbar-brand").attr("href", "http://bioeffect.com/index");
    }
  });
}

$(window).load(function() {
    $('#container1').twentytwenty();
  	$('#container2').twentytwenty();
});